import React from 'react';
import moment from 'moment';

import StatusCard from '../../../../components/StatusCard/index.tsx';
import { useTranslation } from 'react-i18next';

type Props = {
  status: string;
  deliveryDate: string;
};

const ProductDeliveryConfirmedCard: React.FC<Props> = ({
  status,
  deliveryDate
}) => {
  const { t } = useTranslation('ihut');

  return (
    <StatusCard
      status={status}
      imgSrc="/assets/images/ihut/celebration-circle.png"
      showTag
      tagProps={{
        variant: 'tertiary',
        color: 'green',
        text: t('deliveryStatus.confirmed')
      }}
    >
      <StatusCard.Heading>
        {t('shippingInfo.productReceived')}
      </StatusCard.Heading>
      <StatusCard.Caption>
        {t('shippingInfo.confirmedOn', {
          date: moment(deliveryDate).format('MM/DD/YYYY'),
          time: moment(deliveryDate).format('h:mm a')
        })}
      </StatusCard.Caption>
    </StatusCard>
  );
};

export default ProductDeliveryConfirmedCard;
